import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { notesList } from "../../_actions";
import NoteSmallIcon from "../../_icons/NoteSmallIcon";
import Moment from "react-moment";
import "./index.css";
import { Checkbox, Row, Col } from "react-bootstrap";

class NoteCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNote: false,
      action: null
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        selectedNote: this.props.selectedNote,
        action: this.props.action
      };
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setState(() => {
      return {
        selectedNote: nextProps.selectedNote,
        action: nextProps.action
      };
    });
  }

  getDisciplines = discipline => {
    return (
      <span>
        {discipline.map(function (item, i) {
          return (
            <span key={i}>
              {i > 0 ? ", " : null}
              {item.name}
            </span>
          );
        })}
      </span>
    );
  };

  getDevices = devices => {
    if (devices.length === 0) {
      return "-";
    }
    return (
      <span>
        {devices.map(function (item, i) {
          return (
            <span key={i}>
              {i > 0 ? ", " : null}
              {item.name}
            </span>
          );
        })}
      </span>
    );
  };

  getAlertTypes = alertTypes => {
    if (alertTypes.length === 0) {
      return "-";
    }
    return (
      <span>
        {alertTypes.map(function (item, i) {
          return (
            <span key={i}>
              {i > 0 ? ", " : null}
              {item.name}
            </span>
          );
        })}
      </span>
    );
  };

  getPrecincts = precincts => {
    if (precincts.length === 0) {
      return "-";
    }
    return (
      <span>
        {precincts.map(function (item, i) {
          return (
            <span key={i}>
              {i > 0 ? ", " : null}
              {item.name}
            </span>
          );
        })}
      </span>
    );
  };

  renderUser = user => {
    if (!user) {
      return "-";
    } else {
      return user.display_name;
    }
  };

  renderStatus = item => {
    return (
      <div className="note-status">
        <span className={"status-" + item.status}>{item.status_display}</span>
      </div>
    );
  };

  renderLink = (item) => {
    return {
      pathname: "/note/" + item.id + "/view",
      state: { fromAllNote: true }
    };
  }

  renderTitleRow = item => {
    return (
      <div className="row-title">
        <Link to={this.renderLink(item)}>
          <NoteSmallIcon className="small-icon" stroke="#111111" /> {item.title} <span>(ID: {item.id})</span>{" "}
        </Link>
        {this.renderStatus(item)}
      </div>
    );
  };

  renderSecondRow = item => {
    return (
      <Row>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Date Created</span>
              <span className="card-datum-value">
                <Moment format="DD MMM YYYY hh:mma">{item.created}</Moment>
              </span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Disciplines</span>
              <span className="card-datum-value">{this.getDisciplines(item.disciplines)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Precinct</span>
              <span className="card-datum-value">{this.getPrecincts(item.precincts)}</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderThirdRow = item => {
    return (
      <Row>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Owner</span>
              <span className="card-datum-value">{this.renderUser(item.assigned_to)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Devices</span>
              <span className="card-datum-value">{this.getDevices(item.devices)}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Alert Types</span>
              <span className="card-datum-value">{this.getAlertTypes(item.alert_types)}</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  selectNote = e => {
    this.state.action(parseInt(e.target.value, 10));
  };

  render = () => {
    const { item } = this.props;

    return (
      <div className="mainNotePanel">
        <div className="notePanel">
          <div className="checkbox-column">
            <Checkbox
              name="note-checkbox"
              className="styled-checkbox"
              value={item.id}
              onChange={this.selectNote}
              checked={this.state.selectedNote}
            >
              <span className="checkmark" />
            </Checkbox>
          </div>
          <div className="content-column">
            <div>
              {this.renderTitleRow(item)}
              {this.renderSecondRow(item)}
              {this.renderThirdRow(item)}
            </div>
          </div>
          <div className="action-column">
            <Link className="link" to={this.renderLink(item)}>
              View Note
            </Link>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { list } = state.notesList;
  return {
    user,
    list
  };
}

export default connect(
  mapStateToProps,
  { notesList }
)(NoteCard);



// WEBPACK FOOTER //
// ./src/_components/NoteCard/index.js